<template>
  <div id="header_text" class="header-text text-center pt-3 pb-3" :style=" menu?.color ? 'background-color:' + menu?.color + ';':''">
      <h4>{{ menu?.module_title ? menu?.module_title : routerName }}</h4>
  </div>
</template>


<script>
import { ref, onMounted, computed, watch } from 'vue'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import { findMenuItemByName } from '../../utils/common.utils.js'
export default {
    name: 'HeaderTextComponent',
    props: {
        'title':{
            type: String,
            default: 'Sin titulo'
        },
        'class':{
            type: String
        }
    },
    setup() {
      // Define a reactive variable to store your data
      const data = ref(null)
      const store = useStore()
      const route = useRoute()
      const menu = ref(null)
      const routerName = ref(null)
      const colorHeader = ref(null)
      
      watch(() => store.state.menu, () => {
        menu.value = findMenuItemByName(store.state.menu, route.name)
        const routeMeta = store.state.routeMeta;
        routerName.value = routeMeta && routeMeta.name ? routeMeta.name : null
        console.log('pasa menu',store.state.menu, route.name, routerName.value)
      })

      watch(() => route.name, () => {
        menu.value = findMenuItemByName(store.state.menu, route.name)
        const routeMeta = store.state.routeMeta;
        routerName.value = routeMeta && routeMeta.name ? routeMeta.name : null
        console.log('pasa route', store.state.menu)
      })
  
      // Call the fetchData function when the component is mounted
      onMounted(() => {
        menu.value = findMenuItemByName(store.state.menu, route.name)
        const routeMeta = store.state.routeMeta;
        routerName.value = routeMeta && routeMeta.name ? routeMeta.name : null
        console.log('pasa mounted')
      })
  
      //const currentRoute = computed(() => useRoute().name)
      const currentRoute = computed(() => {
          const routeMeta = store.state.routeMeta;
          return routeMeta && routeMeta.module ? routeMeta.module : null
      })
      return {
        // Expose the data to the template
        currentRoute,
        menu,
        colorHeader,
        routerName
      }
    }
  }
</script>

<style scoped>
.header-text{
    background-color: #0b488a;
}

.header-text h4{
    color: white;
    font-size: 1.5rem;
    font-weight: bold;
    /*text-transform: uppercase;*/
    margin: 0;
}
</style>